/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
import FullCalendar from "vue-full-calendar";
Vue.use(FullCalendar);
// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);
import "fullcalendar/dist/fullcalendar.css";

// Use for manage backend timestamp
// Vue.use(require('vue-moment'))

/* import VueMask from 'v-mask'
Vue.use(VueMask);

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside) */

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/style.css";

// Styel-himani
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

if (localStorage.getItem("authToken")) {
    store.dispatch("updateAuthToken", localStorage.getItem("authToken"));
}
if (localStorage.getItem("user")) {
    store.dispatch("updateUser", JSON.parse(localStorage.getItem("user")));
}

//Filters
import "./filters/filters";

// i18n
import i18n from "./i18n/i18n";

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

import fullscreen from "vue-fullscreen";
Vue.use(fullscreen);

import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
Vue.use(VueFlatPickr);

// PrismJS
import "prismjs";
import "prismjs/themes/prism.css";

// Feather font icon
require("./assets/css/iconfont.css");

//use axios
import "./axios";

//Mixin
import "./mixins/mixin";

import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
    moment
});

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");